import { render, staticRenderFns } from "./LifeRecordDashboard.vue?vue&type=template&id=765d3aef"
import script from "./LifeRecordDashboard.vue?vue&type=script&lang=js"
export * from "./LifeRecordDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports